import { useState, useEffect } from "react";
import "../../styles/client.css";
import { Link } from "react-router-dom";
import { fetchAllInvoices } from "../../actions/admin/invoice"; 
import FilterIcon from "../../utils/assets/client/filter.svg";
import DoughnutChart from "../../components/admin/DoughnutChart";

const InvoicePage = () => {
  const [invoiceData, setInvoiceData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetchAllInvoices(token).then((res) => {
      setInvoiceData(res.data);
      console.log("invoices", res);
    });
  }, []);
  const labelData = [
    "Closed",
    "Open",
    "Cancelled"
  ];

  const dataSetValue = [1, 3, 2];
  return (
    <div className="container-fluid bg_color_gray">
        <div className="row">
          <div>
          <h4 className="my-3 px-2">Quick View</h4>
          </div>
        </div>
        {/* doughnut chart and search */}
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            
            <div className="card text-start border_bg_color card_radius d-flex justify-content-center align-items-center">
              
              <DoughnutChart
                labelData={labelData}
                dataSetValue={dataSetValue}
                chartName="Invoices by Status"

              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-3 mt-lg-0">
            <div className="card p-3 border_bg_color card_radius ">
              <p className="f-24">Search Filters</p>
              <div className="row d-flex justify-content-start align-items-center">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label className="form-label">ID</label>
                <input type="text" className="form-control" placeholder="Search ID" />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label className="form-label">Status</label>
                <select className="form-select" name="" id="">
                <option value="" selected>Select Status</option>

                    <option value="Approved">Approved</option>
                    <option value="Declined">Declined</option>
                </select>
                {/* <input type="text" className="form-control" placeholder="" /> */}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 my-3">
                <label className="form-label">Date</label>
                <input type="date" className="form-control" />
              </div>
              </div>
              <div className=" d-flex justify-content-start align-items-start mt-2">
                <button className="btn  bg-black text-white d-flex justify-content-center align-items-center">
                  <img src={FilterIcon} width={20} alt="filter" />
                  <span className="mx-2">Clear Filter</span>
                </button>
                <button className="btn  bg-black text-white mx-3">
                  Search{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* table start */}
        <div className="row">
        <div className="my-3 ">
          <div className="card_radius border_bg_col overflow-hidden">
            <div className="d-flex justify-content-start align-items-center bg-black">
            <p className="txt-head px-3 text-white mb-0 p-2">
             Manage Tickets (s)
            </p>
            {/* <div>
            <div className="input-group">
              <input type="text" className="form-control card_radius" placeholder="Search..."  />
              <span className="input-group-text card_radius" id="basic-addon1"><img src={searchSVG} width={20} alt="search" /></span>
          </div>

           </div> */}
            </div>

           {!invoiceData.length > 0 ? (
              <table className="table table-bordered table-striped table-hover mb-0">
                <thead>
                <tr>
                   <td>Ticket ID</td>
                      <td>Invoice ID</td>
                       <td>Date</td>
                       <td>Device Issue</td>
                       <td>Total</td>
                       <td>Status</td>
                       <td></td>
                     </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      colspan="6"
                      class="table-active"
                      className="text-center txt-p"
                    >
                      No Records
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <table className="table table-hover mb-0">
                <thead>
                <tr>
                      <td className="px-4">Invoice ID</td>
                      <td>Customer Name</td>
                      <td>Device Issue</td>
                      <td>Ticket ID</td>
                       <td>Date</td>
                       <td>Due on</td>
                       <td>Amount</td>
                       <td>Tax</td>
                       <td>Total</td>
                     </tr>
                </thead>
                <tbody>
                  {invoiceData.length > 0 &&
                    invoiceData?.map((item) => {
                      return (
                        <tr>
                               <td className="px-4"> <Link to={`/client/invoices/${item.id}`} className="link_text " style={{fontWeight: "500"}} > {item.id} </Link> </td>
                               <td>{item?.ticket?.lead?.customer?.first_name} {item?.ticket?.lead?.customer?.last_name}</td>
                               <td>{item?.ticket?.lead?.lead_items[0]?.defects[0]?.title}</td>
                               <td> <Link to={`/client/tickets/${item.ticket.id}`} className="link_text">{item.ticket.ticket_id}</Link> </td>
                               <td>
                               {item.created_at
                            ? new Date(item.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                               </td>
                               <td>{item.invoice_due ?? "-"}</td>
                               <td>£ {item.total_price}</td>
                               <td>£ {item.total_tax}</td>
                               <td>£ {item.total_price + item.total_tax}</td>
                            </tr>
                      );
                    })}
                </tbody>
              </table>
            )}
          </div>
        </div>
        </div>
      </div>
  );
};



export default InvoicePage